(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[664],{

/***/ 3059:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/post/[post_id]",
      function () {
        return __webpack_require__(3630);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5564);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9059);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5505);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8966);
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 180px;\n      .pc-inner-container {\n        padding: 12px;\n      }\n      .pc-title {\n        font-size: 14px;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #fff;\n  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n\n  .pc-inner-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    padding: 20px;\n  }\n  .info-area {\n    width: 100%;\n  }\n  .tn-wrapper {\n    width: 100%;\n    display: inline-block;\n    padding-top: 56.25%;\n    position: relative;\n    margin-bottom: 12px;\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n    overflow: hidden;\n  }\n  .tn-wrapper::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.3);\n    opacity: 0;\n    transition: 0.3s opacity ease-in;\n  }\n  .pc-cat {\n    color: ",
        ";\n    text-transform: capitalize;\n  }\n  .pc-title {\n    margin: 12px 0;\n    width: 100%;\n    overflow: hidden;\n    display: block;\n  }\n  .pc-title {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    color: ",
        ";\n  }\n  .pc-date {\n    color: ",
        ";\n  }\n\n  & img {\n    transition: 0.3s transform ease-in;\n  }\n  .pc-inner-container:hover {\n    cursor: pointer;\n    .pc-title > span {\n      text-decoration: underline;\n    }\n    img {\n      transform: scale(1.1);\n    }\n    .tn-wrapper::after {\n      opacity: 1;\n    }\n  }\n  @media screen and (min-width: 1240px) {\n    .pc-title {\n      font-size: 17px;\n    }\n  }\n  @media screen and (max-width: 1239px) {\n    .pc-inner-container {\n      padding: 20px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    .pc-inner-container {\n      padding: 16px;\n    }\n  }\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var PostCard = function(param) {
    var title = param.title, category = param.category, publishedDate = param.publishedDate, thumbnail = param.thumbnail, postId = param.postId, _forPostUI = param.forPostUI, forPostUI = _forPostUI === void 0 ? false : _forPostUI;
    var dispatch = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_7__/* .useBlogContext */ .F)().dispatch;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)().locale;
    var handleClickPostCard = function() {
        // list 에서의 scrollY 위치 기억하기
        var scrollY = window.scrollY;
        dispatch({
            type: "change",
            newState: {
                prevScrollTop: scrollY
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PostCardContainer, {
        forPostUI: forPostUI,
        onClick: handleClickPostCard,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
            href: "/blog/post/".concat(postId),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                className: "pc-inner-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "tn-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__/* .ImgBackgroundWrapper */ .Yo, {
                            isNormalUse: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: thumbnail,
                                layout: "fill",
                                alt: title,
                                className: "target-img",
                                objectFit: "cover",
                                quality: 40
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "info-area",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_3__/* .BodyTextSStrong */ .dH, {
                                className: "pc-cat",
                                children: category
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_3__/* .SubtitleM */ .sy, {
                                className: "pc-title",
                                children: title.replaceAll("&#8216;", "‘").replaceAll("&#8217;", "’")
                            }),
                            publishedDate && !forPostUI && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_3__/* .BodyTextS */ .Ei, {
                                className: "pc-date",
                                children: locale === "en" ? (0,date_fns_format__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Date(publishedDate.slice(0, 10)), "yyyy-MM-dd") : (0,date_fns_format__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Date(publishedDate.slice(0, 10)), "yyyy년 MM월 dd일")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCard);
var PostCardContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "PostCard__PostCardContainer",
    componentId: "sc-6859d5ea-0"
})(_templateObject1(), global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY90 */ .cW, global_styles__WEBPACK_IMPORTED_MODULE_3__.BB, global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY20 */ .sF, global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY60 */ .Ts, function(param) {
    var forPostUI = param.forPostUI;
    return forPostUI === true && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject());
});


/***/ }),

/***/ 1924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Global_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6402);
/* harmony import */ var components_Popup_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(763);
/* harmony import */ var hooks_useContactModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5378);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .io-target {\n    position: absolute;\n    top: 0;\n    height: 60px;\n    width: 100%;\n    z-index: -1;\n  }\n  position: fixed;\n  z-index: 99;\n  bottom: 56px;\n  text-align: right;\n  right: 32px;\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    bottom: 32px;\n    right: 32px;\n  }\n  @media screen and (max-width: 599px) {\n    bottom: 32px;\n    right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FloatingController = function(param) {
    var isVisible = param.isVisible;
    var ref = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_4__/* .useContactModal */ .s)(), isContactModalOpen = ref.isContactModalOpen, handleCloseContactModal = ref.handleCloseContactModal, handleOpenContactModal = ref.handleOpenContactModal;
    var handleClickScrollBtn = function() {
        if (!isVisible) (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_5__/* .scrollTo */ .X5)(window, {
            top: 0,
            behavior: "smooth"
        });
        else {
            var $aboutMainBanner = document.querySelector(".main-section-container");
            if ($aboutMainBanner) {
                var scrollValue = $aboutMainBanner.getBoundingClientRect().height;
                (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_5__/* .scrollTo */ .X5)(window, {
                    top: scrollValue,
                    behavior: "smooth"
                });
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FloatingControllerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ScrollButton */ .xE, {
                isOpenContact: isContactModalOpen,
                isScrolled: !isVisible,
                onClick: handleClickScrollBtn
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ContactButton */ .AI, {
                onClick: handleOpenContactModal
            }),
            isContactModalOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Popup_index__WEBPACK_IMPORTED_MODULE_3__/* .ContactPopup */ .rb, {
                handleCloseContact: handleCloseContactModal
            })
        ]
    });
};
var FloatingControllerContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FloatingController__FloatingControllerContainer",
    componentId: "sc-6a16d34b-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (FloatingController);


/***/ }),

/***/ 9702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ GlassLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5505);
/* harmony import */ var react_loader_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8756);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  flex-direction: column;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GlassLoader = function(param) {
    var loadingText = param.loadingText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(GlassLoaderContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loader_spinner__WEBPACK_IMPORTED_MODULE_3__/* .MagnifyingGlass */ .Yt, {
                visible: true,
                height: "100",
                width: "100",
                ariaLabel: "MagnifyingGlass-loading",
                wrapperStyle: {},
                wrapperClass: "MagnifyingGlass-wrapper",
                glassColor: "#c0efff",
                color: global_styles__WEBPACK_IMPORTED_MODULE_2__/* .BBBright */ .DS
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_2__.H5, {
                children: loadingText
            })
        ]
    });
};
var GlassLoaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "GlassLoader__GlassLoaderContainer",
    componentId: "sc-deed26d0-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_2__/* .GRAY20 */ .sF);


/***/ }),

/***/ 9766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var global_styles_MainButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8920);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1089);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9059);
/* harmony import */ var hooks_useContactModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2921);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 103.5px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: ",
        ";\n  text-align: center;\n  color: #fff;\n\n  @media screen and (max-width: 1239px) {\n    padding: 56px 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ProductContactUs = function(param) {
    var locale = param.locale;
    var handleOpenContactModal = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_5__/* .useContactModal */ .s)().handleOpenContactModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProductContactUsContainer, {
        children: [
            locale === "en" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__.H2, {
                        as: "p",
                        children: "Inquiry For more information,"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__.H2, {
                        as: "p",
                        children: "please contact us."
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__/* .H2KR */ .Zj, {
                        as: "p",
                        children: "제품\xb7기술과 관련된"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__/* .H2KR */ .Zj, {
                        as: "p",
                        children: "궁금한 점이 있으시면 문의를 남겨주세요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles_MainButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                buttonType: "default-w",
                text: locale === "en" ? "Contact Us" : "문의하러 가기",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_3__/* .ReceiverIcon */ .dt, {}),
                iconPosition: "left",
                style: {
                    marginTop: "32px",
                    width: "328px",
                    height: "48px"
                },
                onClick: handleOpenContactModal
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductContactUs);
var ProductContactUsContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "ProductContactUs__ProductContactUsContainer",
    componentId: "sc-724278fc-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_4__/* .BBINDIGO */ ._4);


/***/ }),

/***/ 3630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _post_id_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./components/NewHeader/index.tsx + 19 modules
var NewHeader = __webpack_require__(614);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ./components/Common/GlassLoader.tsx
var GlassLoader = __webpack_require__(9702);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var MainButton = __webpack_require__(8920);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./react-query/blogHooks.ts + 1 modules
var blogHooks = __webpack_require__(640);
// EXTERNAL MODULE: ./components/Blog/PostCard.tsx
var PostCard = __webpack_require__(4357);
;// CONCATENATED MODULE: ./public/asset/blog/share/linkedin.png
/* harmony default export */ var linkedin = ({"src":"/_next/static/media/linkedin.b323cea8.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEUAeLUAeLYBd7YAbbBlrdPG4e8AdLU3lMWYyOFMoMyx1umFvtwfiL6RxeCn0OYXMGzVAAAAAnRSTlPBxDh7LZ4AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA4SURBVHicHcrBEcAwCAMw1wYDSbr/ur3mp4fwUCQJsMJXikXShKY7swxFZqyti+pXf44zY4CSZXwk7AElKSptwQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/blog/share/naverblog.png
/* harmony default export */ var naverblog = ({"src":"/_next/static/media/naverblog.bb2fe371.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEX///76t4/8xqb7zrIjrjya2qWL2Jx5z4oxtEmD0pE1tU1Eulr+8ev2wJrH683G6804tk7/3c04tk8SPkQTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAPElEQVR4nCXJxw3AQAwDMLnKvpK2/7ABEn6JYHc3A8SHSN1qdifStopI/rVW4yGPk7xQ7nO6F6JG1ah4ATM/AZdcbb6yAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/blog/share/twitter.png
/* harmony default export */ var twitter = ({"src":"/_next/static/media/twitter.7120e755.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEUBqPWo4fsCqvcFqO8FrfhRyPoAp/ZMaXEasfYBpPICqPPx+v4Ap/EDrPcGsPv////Y8v4Uuv8xxP/I7P1ZUO1sAAAADnRSTlP5/q8w6v6zAP4uuP0t6DMX800AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA8SURBVHicBcGJAcAgCACxww/QFtTuv2sTtE6YrtQW2GnO6N32ugV67lwGxJcpwDiSYlHwdo14HfUB5dEfRN0B7V8/LIAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/Blog/PostContentArea.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .share-link {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .share-link.copy-link {\n    width: 32px;\n    height: 32px;\n    margin-left: 6px;\n  }\n  .share-icon {\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n  .related-post-area {\n    padding-top: 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .related-post-wrapper {\n    width: 100%;\n  }\n  .related-post-t {\n    text-align: center;\n    margin: 40px 0;\n    color: ",
        ";\n  }\n  .related-post-list {\n    width: 100%;\n    text-align: left;\n    display: flex;\n    justify-content: center;\n    padding: 4px;\n  }\n  .related-post-list > li {\n    flex-shrink: 0;\n  }\n\n  .related-post-list > li + li {\n    margin-left: 16px;\n  }\n\n  .link-area {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px 0;\n    margin-bottom: 16px;\n    padding-top: 64px;\n  }\n  .link-area > * + * {\n    margin-left: 12px;\n  }\n\n  .tags-area {\n    display: flex;\n    padding: 8px 0;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n  .content-area {\n    border-bottom: 1px solid ",
        ";\n    padding: 32px 0;\n    *,\n    *::before,\n    *::after {\n      font-size: 14px;\n      font-family: 'Noto Sans KR', sans-serif;\n    }\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-weight: bold;\n      padding: 8px 0;\n    }\n    h2,\n    h3,\n    h4 {\n      color: #111;\n      line-height: 120%;\n    }\n    h2 {\n      font-size: 24px;\n      line-height: 40px;\n    }\n    h3 {\n      font-size: 19px;\n      line-height: 29px;\n    }\n    h4 {\n      font-size: 16px;\n      line-height: 26px;\n    }\n    h5 {\n      font-size: 13px;\n      line-height: 21px;\n    }\n    h6 {\n      font-size: 10px;\n      line-height: 17px;\n    }\n\n    ul {\n      padding-left: 16px;\n      list-style: disc;\n    }\n    ul ul {\n      list-style: circle;\n      margin: 0;\n    }\n    ul ul ul {\n      margin: 0;\n      list-style: square;\n    }\n    ol {\n      padding-left: 16px;\n      list-style: number;\n    }\n    ol ol,\n    ol ol ol {\n      margin: 0;\n    }\n    ul,\n    ol {\n      margin: 8px;\n    }\n    a {\n      text-decoration: underline;\n    }\n    a:visited {\n      color: ",
        ";\n    }\n    p {\n      min-height: 14px;\n    }\n\n    /* 컨텐츠 컨테이너 */\n    .site-content {\n      margin: 0 auto !important;\n      max-width: 1200px !important;\n    }\n\n    /* 인용문 */\n    .wp-block-quote {\n      margin: 16px 0;\n      padding: 8px;\n      border-radius: 4px;\n      border-left: 4px solid #00428e;\n      background: #f2f6f9;\n      min-height: 48px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .wp-block-quote > p {\n      display: none;\n    }\n    .wp-block-quote > cite {\n      font-style: normal;\n      font-size: 14px;\n    }\n\n    .wp-block-image img {\n      height: auto;\n      max-width: 1000px;\n    }\n    .alignwide img {\n      width: 100%;\n    }\n\n    .wp-block-image {\n      width: 100%;\n    }\n\n    .wp-block-video {\n      padding: 16px 0;\n    }\n    .wp-block-video video {\n      height: auto;\n      max-width: 1000px;\n      width: 100%;\n    }\n    .wp-block-embed {\n      padding: 16px 0;\n      text-align: center;\n      height: auto;\n      width: 100%;\n      max-width: 1000px;\n    }\n    .wp-block-embed__wrapper {\n      position: relative;\n      height: auto;\n    }\n    .wp-block-embed__wrapper::before {\n      content: '';\n      display: block;\n    }\n    .embed-youtube .youtube-player {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      width: 100%;\n      height: 100%;\n    }\n    .embed-videopress {\n      width: 100% !important;\n      height: auto !important;\n    }\n\n    .wp-embed-aspect-16-9 .wp-block-embed__wrapper::before {\n      padding-top: 56.25%;\n    }\n    .wp-embed-aspect-4-3 .wp-block-embed__wrapper::before {\n      padding-top: 75%;\n    }\n    .wp-embed-aspect-1-1 .wp-block-embed__wrapper::before {\n      padding-top: 100%;\n    }\n\n    figure {\n      clear: both;\n      text-align: center;\n      margin: 16px 0;\n      max-width: 100%;\n      display: table;\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    figure.is-provider-videopress .wp-block-embed__wrapper::before {\n      display: none;\n    }\n\n    .is-provider-videopress div.padding-wrapper {\n      padding-top: 56.25%;\n    }\n\n    figure.is-provider-videopress iframe {\n      height: 100%;\n      width: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    /* 이미지 캡션 */\n    figcaption.wp-element-caption,\n    figcaption {\n      color: #808080;\n      font-size: 13px;\n      margin: 0 auto;\n      margin-top: 8px;\n      line-height: 23px;\n      letter-spacing: -0.01em;\n      display: table-caption;\n      caption-side: bottom;\n      max-width: 1000px;\n    }\n\n    /* 일반 텍스트, 목록 */\n    p,\n    li {\n      color: #000;\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 180%;\n    }\n\n    .wp-block-button a.wp-block-button__link {\n      display: inline-block;\n      margin: 0;\n      color: #fff;\n      background-color: #32373c;\n      border-radius: 9999px;\n      box-shadow: none;\n      text-decoration: none;\n      padding: calc(0.667em + 2px) calc(1.333em + 2px);\n      font-size: 16px;\n      transition: background-color 0.2s;\n    }\n\n    .wp-block-button a.wp-block-button__link:hover {\n      background-color: #1f2225;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    p,\n    ul,\n    li,\n    a,\n    .wp-block-buttons,\n    .wp-block-quote {\n      max-width: 768px;\n      margin: 0 auto;\n    }\n    .wp-block-buttons {\n      padding: 8px 0;\n      text-align: center;\n    }\n    .has-text-align-center {\n      text-align: center;\n    }\n\n    p + p {\n      margin-top: 16px;\n    }\n    strong {\n      font-size: inherit;\n      font-weight: bold;\n    }\n  }\n  @media screen and (max-width: 1239px) {\n    .content-area {\n      padding: 16px 0;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    figcaption.wp-element-caption {\n      margin-top: 8px;\n    }\n    .related-post-list {\n      justify-content: flex-start;\n      overflow-x: auto;\n    }\n    .related-post-list > li + li {\n      margin-left: 8px;\n    }\n    .tags-area {\n      justify-content: center;\n    }\n    .content-area {\n      padding: 8px 0;\n    }\n    .aligncenter img {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  color: ",
        ";\n  font-size: 15px;\n  font-weight: 500;\n  padding: 6px 20px;\n  border: 1px solid ",
        ";\n  border-radius: 40px;\n  flex-shrink: 0;\n  margin-top: 4px;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  font-family: 'Noto Sans KR', sans-serif;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var PostContentArea = function(param) {
    var content = param.content, tags = param.tags, postId = param.postId, title = param.title;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,blogHooks/* useRelatedPostList */.qd)(postId), data = ref.data, isLoading = ref.isLoading, isFetching = ref.isFetching;
    var relatedPosts = data === null || data === void 0 ? void 0 : data.posts;
    var contentHTML = {
        __html: content
    };
    var handleCopyURL = function() {
        navigator.clipboard.writeText(window.location.href).then(function() {
            window.alert("URL Copied to the clipboard.");
        }).catch(function() {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostContentAreaContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-area",
                dangerouslySetInnerHTML: contentHTML
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "link-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://twitter.com/intent/tweet?url=https://blue-dot.io/ko/blog/post/".concat(postId, "&text=").concat(title),
                        target: "_blank",
                        rel: "noreferrer",
                        className: "twitter-share-button share-link",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "share-icon",
                            style: {
                                backgroundImage: 'url("'.concat(twitter.src, '")')
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "share-link",
                        target: "_blank",
                        rel: "noreferrer",
                        href: "http://blog.naver.com/openapi/share?url=https://blue-dot.io/ko/blog/post/".concat(postId, "&text=").concat(title),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "share-icon",
                            style: {
                                backgroundImage: 'url("'.concat(naverblog.src, '")')
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "share-link",
                        href: "https://www.linkedin.com/sharing/share-offsite/?url=$https://blue-dot.io/ko/blog/post/".concat(postId),
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "share-icon",
                            style: {
                                backgroundImage: 'url("'.concat(linkedin.src, '")')
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "share-link copy-link",
                        onClick: handleCopyURL,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LinkIcon */.xP, {})
                    })
                ]
            }),
            tags && tags.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "tags-area",
                children: tags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "#"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tag
                            })
                        ]
                    }, tag);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "related-post-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                            tag: "a",
                            buttonType: "default",
                            text: locale === "en" ? "Go to list" : "목록으로",
                            className: "ok-btn",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowIcon */.e0, {}),
                            iconPosition: "left",
                            injectInlineStyles: {
                                width: "147px",
                                height: "48px"
                            }
                        })
                    }),
                    isLoading || isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlassLoader/* GlassLoader */.y, {
                        loadingText: "Loading Events..."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: relatedPosts && relatedPosts.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "related-post-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                                    className: "related-post-t",
                                    children: locale === "en" ? "Related posts" : "연관 포스트"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "related-post-list",
                                    children: relatedPosts.map(function(rp) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                                            title: rp.title,
                                            category: rp.category,
                                            thumbnail: rp.thumbnail,
                                            postId: rp.id,
                                            forPostUI: true
                                        }, rp.id);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Blog_PostContentArea = (PostContentArea);
var PostContentAreaContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "PostContentArea__PostContentAreaContainer",
    componentId: "sc-c3bcfb5e-0"
})(_templateObject(), global_styles/* GRAY20 */.sF, global_styles/* GRAY90 */.cW, global_styles/* BBBright */.DS);
var Tag = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "PostContentArea__Tag",
    componentId: "sc-c3bcfb5e-1"
})(_templateObject1(), global_styles.SB, global_styles/* BBDARK */.wz, global_styles/* GRAY80 */.OD);

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 34 modules
var format = __webpack_require__(8966);
;// CONCATENATED MODULE: ./components/Blog/PostMetaDataArea.tsx

function PostMetaDataArea_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 32px;\n  .top-area {\n    padding-bottom: 32px;\n    border-bottom: 1px solid ",
        ";\n    margin-bottom: 16px;\n  }\n  .cat-name {\n    color: ",
        ";\n    margin-bottom: 10px;\n    text-transform: capitalize;\n  }\n\n  .date-author {\n    margin-bottom: 4px;\n    color: ",
        ";\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .post-type {\n    text-align: right;\n    color: ",
        ";\n    text-transform: capitalize;\n  }\n  @media screen and (max-width: 1239px) {\n    margin-bottom: 16px;\n  }\n\n  @media screen and (max-width: 599px) {\n    margin-bottom: 8px;\n    .top-area {\n      padding-bottom: 16px;\n    }\n  }\n"
    ]);
    PostMetaDataArea_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var postTypeLabel = {
    "pulsar-avif": "Pulsar-AVIF",
    "pulsar-av1": "Pulsar-AV1",
    "pulsar-vmaf": "Pulsar-VMAF",
    "deepfield-sr": "DeepField-SR",
    "deepfield-pqo": "DeepField-PQO",
    bluedot: "BLUEDOT"
};
var PostMetaDataArea = function(param) {
    var category = param.category, title = param.title, author = param.author, publishedDate = param.publishedDate, postType = param.postType;
    var dateTyped = new Date(publishedDate.slice(0, 10));
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostMetaDataAreaContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextLStrong */.zY, {
                        className: "cat-name",
                        children: category
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H3KR */.nX, {
                        as: "h2",
                        className: "title-t",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bottom-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "date-author",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextM */.OV, {
                                children: locale === "en" ? (0,format/* default */.Z)(dateTyped, "yyyy-MM-dd") : (0,format/* default */.Z)(dateTyped, "yyyy년 MM월 dd일")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* BodyTextM */.OV, {
                                children: [
                                    locale === "en" ? "Writer" : "작성자",
                                    ": ",
                                    author
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                        className: "post-type",
                        children: postTypeLabel[postType.toLocaleLowerCase()]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Blog_PostMetaDataArea = (PostMetaDataArea);
var PostMetaDataAreaContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "PostMetaDataArea__PostMetaDataAreaContainer",
    componentId: "sc-6debd414-0"
})(PostMetaDataArea_templateObject(), global_styles/* GRAY90 */.cW, global_styles.SB, global_styles/* GRAY40 */.vm, global_styles/* BBBright */.DS);

;// CONCATENATED MODULE: ./components/Blog/PostContent.tsx

function PostContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .post-inner-container {\n    @media screen and (min-width: 1440px) {\n      width: 100%;\n      max-width: 1200px;\n      margin: 128px auto;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      width: calc(100% - 192px);\n      margin: 96px;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      width: calc(100% - 112px);\n      margin: 56px;\n    }\n    @media screen and (min-width: 600px) and (max-width: 904px) {\n      width: calc(100% - 64px);\n      margin: 32px;\n    }\n    @media screen and (max-width: 599px) {\n      width: calc(100% - 32px);\n      margin: 32px 16px;\n    }\n  }\n"
    ]);
    PostContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var PostContent = function(param) {
    var post = param.post;
    var postTitle = post.title.replaceAll("&#8216;", "‘").replaceAll("&#8217;", "’");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContentContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "post-inner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_PostMetaDataArea, {
                    category: post.category,
                    // title={post.title}
                    title: postTitle,
                    author: post.author,
                    publishedDate: post.date,
                    postType: post.post_type
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_PostContentArea, {
                    // title={post.title}
                    title: postTitle,
                    postId: post.id,
                    content: post.content,
                    tags: post.tags,
                    postType: post.post_type
                })
            ]
        })
    });
};
/* harmony default export */ var Blog_PostContent = (PostContent);
var PostContentContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "PostContent__PostContentContainer",
    componentId: "sc-3d3d4661-0"
})(PostContent_templateObject());

// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
// EXTERNAL MODULE: ./components/Common/FloatingController.tsx
var FloatingController = __webpack_require__(1924);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(2587);
// EXTERNAL MODULE: ./components/Product/ProductContactUs.tsx
var ProductContactUs = __webpack_require__(9766);
// EXTERNAL MODULE: ./public/asset/bluedot-metatag-img.png
var bluedot_metatag_img = __webpack_require__(2446);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(5351);
;// CONCATENATED MODULE: ./pages/blog/post/[post_id].tsx

function _post_id_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .io-target {\n    height: 60px;\n  }\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    .io-target {\n      height: 52px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    .io-target {\n      height: 44px;\n    }\n  }\n"
    ]);
    _post_id_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var Post = function(param) {
    var post = param.post;
    console.log(post);
    var locale = (0,router.useRouter)().locale;
    (0,blogHooks/* useIncreasePostViewCount */.Ut)(post.id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat(post.title, " | ").concat(post.category, " - BLUEDOT Blog"),
                description: "".concat(post.excerpt || post.title + post.category),
                canonical: "https://blue-dot.io/ko/blog/post/".concat(post.id),
                openGraph: {
                    url: "https://blue-dot.io/ko/blog/post/".concat(post.id),
                    title: "".concat(post.title, " | ").concat(post.category, " - BLUEDOT Blog"),
                    description: "".concat(post.excerpt || post.title + post.category),
                    images: [
                        {
                            url: post.thumbnail || bluedot_metatag_img/* default.src */.Z.src,
                            alt: "BLUEDOT INC.",
                            type: "image/png"
                        }, 
                    ],
                    siteName: "BLUEDOT"
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader/* default */.Z, {
                isScrolled: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "io-target"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_PostContent, {
                post: post
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContactUs/* default */.Z, {
                locale: locale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingController/* default */.Z, {
                isVisible: false
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _post_id_ = (Post);
var PostContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* PageOuterContainer */.px).withConfig({
    displayName: "[post_id]__PostContainer",
    componentId: "sc-10d3377d-0"
})(_post_id_templateObject());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [726,769,351,605,572,352,774,888,179], function() { return __webpack_exec__(3059); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);